import { Drawer } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../hooks';
import DrawerHeader from '../../Layout/DrawerHeader';
import Comps, { type CompsProps } from './Comps';
import {
    closeDrawer,
    DrawerRenderType,
    selectDrawerOpen,
    selectDrawerRender,
    selectRenderParams,
} from './rightDrawerSlice';
// import EditableTakes, { type EditableTakesProps } from './Takes/EditableTakes';
import Takes, { type TakesProps } from './Takes/Takes';


export default function RightDrawer() {
    const open = useSelector(selectDrawerOpen);
    const render = useSelector(selectDrawerRender);
    const params = useSelector(selectRenderParams)
    const dispatch = useAppDispatch();

    const location = useLocation();
    const prevLocation = useRef<string>();

    useEffect(() => {
        if (open && render !== DrawerRenderType.none && location.key !== prevLocation.current) {
            // page navigation is loading, close the drawer
            dispatch(closeDrawer());
        }
        prevLocation.current = location.key;
    }, [dispatch, location.key, open, render]);

    const renderContent = () => {
        switch (render) {
            case DrawerRenderType.takes:
                return <Takes { ...params as TakesProps } />;
            // case DrawerRenderType.editableTakes:
                // return <EditableTakes { ...params as EditableTakesProps } />;
            case DrawerRenderType.comps:
                return <Comps { ...params as CompsProps } />;
            case DrawerRenderType.none:
                return null;
        }
    }

    return (
        <Drawer
            sx={{
                width: 280,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 280,
                },
            }}
            variant='persistent'
            anchor='right'
            open={open}
        >
            <DrawerHeader />
            {renderContent()}
        </Drawer>
    );
}